/**
 * 充值下单模块
 */
import React, {Component} from 'react';
import loading from 'c-up-loading';
import Cache from 'c-cache';
import Timer from 'c-timer';
import notification from 'c-notification';
import PbAjax from '../../../lib/pbajax';
import Url from 'c-url';
import publicpb from '../../../base/public.pb';
import orderpb from '../pb/orderpb';
import lang from '../../../lang';
import channelConfig from '../config';
import PayResult from '../payresult/';
import bankRecharge from '../bank/';
import ccnetRecharge from '../ccnet/';

const pbajax = new PbAjax();

export default (ComposedComponent) => {

    class Order extends Component {
        static defaultProps = {
            uid: '', // 下单用户UID
            channel: '' // 使用的充值方式
        }

        constructor(props) {
            super(props);
            
            this.state = {
                uid: props.uid,
                channel: props.channel,
                showQrcode: 0,
                remainTime: 60
            }

            this.cache = new Cache({
                prefix: 'pcuplive'
            });
        }

        componentWillReceiveProps(nextProps) {
            this.setState({
                channel: nextProps.channel
            });
        }

        componentWillUnmount() {
            this.checkPayStatusTimer && clearTimeout(this.checkPayStatusTimer);
            this.singleVerifyTimer && clearTimeout(this.singleVerifyTimer);
            this.timer && this.timer.destroy();
        }

        onSelectPay(product, ext) {
            
            let returnUrl = window.location.href.replace(location.hash, '');
            let channel = this.state.channel;
            
            returnUrl = Url.addParam(returnUrl, { 
                paidfrom: encodeURIComponent(UP.Global.currentPathName),
                productId: Number(product.configId),
                channel: channel
            });
            
            let clientType = Url.query('clientType') || 'pcuplive';
            let data = {
                purpose: 1, // 钻石
                productId: Number(product.configId),
                channel: this.state.channel,
                tradeType: channelConfig[channel].tradeType,
                tuid: Number(this.state.uid),
                returnUrl: returnUrl,
                clientType
            };

            if (ext) {
                data.ext = JSON.stringify(ext);
            }
            
            this.submit(data, product); 
        }

        // 微信支付
        // 二维码生成后的支付状态检验
        // 在组件销毁时要销毁此定时器
        checkPayStatus(orderId) {
            this.verify(orderId);
            this.checkPayStatusTimer = setTimeout(()=>{
                this.setState({
                    showQrcode: 0,
                    qrcodeUrl: ''
                });
                $.channel.emit('rechargeError');
                // 销毁单此校验定时器
                clearTimeout(this.singleVerifyTimer);
            }, 60 * 1000);

            this.timer && this.timer.destroy();
            this.timer = new Timer({
                remainTime: 60
            });

            this.timer.on('tick', (e)=>{
                this.setState({
                    remainTime: Math.floor(e.remainTime)
                });
            })
        }

        // 校验订单是否已成功到账
        verify(orderId) {
            if (!this.verifyOrder) {
                this.verifyOrder = new PayResult(orderId);
            } else {
                // retry时会生成新的promise
                this.verifyOrder.retry();
            }

            this.verifyOrder.promise.done((resp)=>{
                
                this.setState({
                    showQrcode: 0,
                    qrcodeUrl: ''
                });

                this.verifyOrder = null;
                clearTimeout(this.checkPayStatusTimer);
                $.channel.emit('rechargeSuccess', resp);
            }).fail(()=>{
                this.singleVerifyTimer = setTimeout(()=>{
                    this.verify(orderId);
                }, 2000);
            });
        }

        submit(data, product) {
            
            loading.show({
                content: lang.template('正在购买')
            });

            let cacheOrderKey = '_u_orderId_' + data.productId;

            pbajax.do(
                {
                    service: 'mall',    
                    api: '/mall/pay/order',  
                    inchina: 1,
                    header: {
                        lang: UP.Global.siteLanguage
                    }
                }, 

                new orderpb.Mall.PayOrder.Request(data), 

                (res) => {

                    loading.hide();
                    let dataWrap = publicpb.Result.decode(res);
                    
                    if (dataWrap.code == 1) {
                        let data = orderpb.Mall.PayOrder.Response.decode(dataWrap.data.value);
                        let channel = this.state.channel;
                        let orderId = data.orderInfo.orderId;
                        
                        this.cache.setCache(cacheOrderKey, orderId);
                        
                        switch(channel) {
                            case 'pepay_entitycard_thb':
                            case 'pepay_entitycard_idr':
                            case 'pepay_onlinebank_idr':
                            case 'pepay_alfamart_idr':
                            case 'pepay_webatm_idr':
                            case 'pepay_onlinebank_vnd':
                            case 'pepay_entitycard_vnd':
                            case 'paytm':   
                            case 'gash':
                            case 'gash_card':
                                let backAddr = data.h5;
                                let [actions, attrs] = backAddr.split('?');

                                if (attrs) {
                                    let arr = attrs.split('&');

                                    arr = arr.map((item, i)=>{
                                        const firstEqIdx = item.indexOf('=');
                                        const key = item.substr(0, firstEqIdx);
                                        const v = item.substr(firstEqIdx + 1);
                                        return '<input type="hidden" name="' + key + '" value="' + v + '" />';
                                    });

                                    let forms = [
                                        '<form method="post" action="' + actions + '">',
                                        ...arr,
                                        '</form>'
                                    ];
                                    let $form = $(forms.join(''));
                                    $(document.body).append($form);

                                    $form[0].submit();
                                }
                                break;
                            case 'alipay':
                                let form = $(data.alipay);
                            
                                $(document.body).append(form);

                                setTimeout(function() {
                                    document.forms[0].submit();
                                });

                                break;
                            case 'wxpay':
                                // 微信扫码支付
                                let code_url = JSON.parse(data.wxpay).code_url;
                                let orderId = data.orderInfo.orderId;
                                
                                this.setState({
                                    showQrcode: 1,
                                    qrcodeUrl: code_url
                                })
                                // 二维码生成后
                                // 60s内每2s请求一次验证接口
                                // 60s后用户未付款，提示充值失败并提示用户从新充值
                                // 验证通过后，调用通用的充值成功逻辑
                                this.checkPayStatus(orderId);

                                break;
                            case 'sinopac_atm':
                                bankRecharge.create({
                                    orderId: data.h5,
                                    product: product
                                });
                                break;
                            case 'pepay_credit':
                            case 'pepay_store_ibon_twd':
                            case 'pepay_store_fami_twd':
                            case 'pepay_store_hilifeet_twd':
                            case 'pepay_store_okgo_twd':
                                ccnetRecharge.create({
                                    data: data,
                                    orderId: data.orderInfo.orderId,
                                    product: product,
                                    orderBank: channel == 'pepay_credit' ? lang.template('CCNET-信用卡') : lang.template('CCNET-便利超商代收')
                                });
                                break;
                            case 'bk_atm':
                                let payUrl = data.h5;
                                
                                payUrl = payUrl.replace('zh-CN', 'vi-VN');
                                payUrl += '&web=3';

                                location.replace(payUrl);
                                break;
                            default: 
                                location.replace(data.h5);     
                        }
                    } else if(dataWrap.code == 12293){ 
                        notification.simple(lang.template('金额或次数限充'));    
                    } else {
                        $.channel.emit('rechargeError', dataWrap.code);
                        // notification.simple(lang.template('下单失败'));
                    }
                },

                () => {
                    loading.hide();
                    
                    notification.simple(lang.template('网络连接有误, 请稍后再试'));
                }
            );
        }
        render() {

            return (
                <ComposedComponent {...this.state} onSelectPay={this.onSelectPay.bind(this)}
                />
            );
        }
    }

    return Order;
}



// WEBPACK FOOTER //
// ./js/component/recharge/order/h5.js